(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-marquee-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SMOOTHING = 8;

  function initMarquee(root) {
    if (!root || root.dataset.marqueeInitialized === 'true') return;

    var track = root.querySelector('[data-image-marquee-track]');
    var group = root.querySelector('[data-image-marquee-group]');
    if (!track || !group) return;

    root.dataset.marqueeInitialized = 'true';

    var prev = root.querySelector('[data-image-marquee-prev]');
    var next = root.querySelector('[data-image-marquee-next]');
    var toggle = root.querySelector('[data-image-marquee-toggle]');
    var pauseIcon = root.querySelector('[data-image-marquee-icon-pause]');
    var playIcon = root.querySelector('[data-image-marquee-icon-play]');

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = parseFloat(root.dataset.speed) || 0;
    var playing = root.dataset.autoplay === 'true' && !reducedMotion && speed > 0;

    var offset = 0;
    var target = 0;
    var loopWidth = 0;
    var lastTime = 0;
    var frame = null;

    function gap() {
      return parseFloat(getComputedStyle(root).getPropertyValue('--image-marquee-gap')) || 0;
    }

    function buildLoop() {
      var clones = track.querySelectorAll('[data-image-marquee-clone]');
      for (var i = 0; i < clones.length; i++) {
        clones[i].remove();
      }

      var groupWidth = group.offsetWidth;
      if (groupWidth === 0) return;

      loopWidth = groupWidth + gap();

      var needed = Math.ceil((root.offsetWidth + loopWidth) / loopWidth);
      for (var c = 0; c < needed; c++) {
        var clone = group.cloneNode(true);
        clone.setAttribute('data-image-marquee-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-image-marquee-group');
        track.appendChild(clone);
      }

      offset = offset % loopWidth;
      target = offset;
      render();
    }

    function render() {
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
    }

    function tick(now) {
      var delta = lastTime ? Math.min((now - lastTime) / 1000, 0.05) : 0;
      lastTime = now;

      if (playing) target += speed * delta;

      offset += (target - offset) * Math.min(1, delta * SMOOTHING);

      if (loopWidth > 0) {
        while (offset >= loopWidth) {
          offset -= loopWidth;
          target -= loopWidth;
        }
        while (offset < 0) {
          offset += loopWidth;
          target += loopWidth;
        }
      }

      render();
      frame = window.requestAnimationFrame(tick);
    }

    function step(direction) {
      var item = group.querySelector('.image-marquee__item');
      var distance = item ? item.offsetWidth + gap() : loopWidth;
      target += direction * distance;
    }

    function setPlaying(value) {
      playing = value;
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
      if (pauseIcon) pauseIcon.classList.toggle('image-marquee__icon--hidden', !playing);
      if (playIcon) playIcon.classList.toggle('image-marquee__icon--hidden', playing);
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (toggle) toggle.addEventListener('click', function () { setPlaying(!playing); });

    var startX = 0;
    var startTarget = 0;
    var swiping = false;

    track.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      startTarget = target;
      swiping = true;
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      if (!swiping) return;
      target = startTarget - (event.touches[0].clientX - startX);
    }, { passive: true });

    track.addEventListener('touchend', function () {
      swiping = false;
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(buildLoop, 200);
    });

    var images = group.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      if (!images[i].complete) images[i].addEventListener('load', buildLoop, { once: true });
    }

    setPlaying(playing);
    buildLoop();
    frame = window.requestAnimationFrame(tick);

    root.addEventListener('marquee:destroy', function () {
      if (frame) window.cancelAnimationFrame(frame);
    });
  }

  function initAll(scope) {
    var marquees = (scope || document).querySelectorAll('[data-image-marquee]');
    for (var i = 0; i < marquees.length; i++) {
      initMarquee(marquees[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var marquee = event.target.querySelector('[data-image-marquee]');
    if (marquee) marquee.dispatchEvent(new CustomEvent('marquee:destroy'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-awards-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_FRAME_SECONDS = 0.05;

  function createRow(row, speed, pauseOnHover) {
    var track = row.querySelector('[data-pam-track]');
    var group = row.querySelector('[data-pam-group]');
    if (!track || !group) return null;

    var direction = row.dataset.direction === 'right' ? 1 : -1;
    var offset = 0;
    var loopWidth = 0;
    var hovered = false;

    function removeClones() {
      var clones = track.querySelectorAll('[data-pam-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].remove();
    }

    function cloneGroup() {
      var clone = group.cloneNode(true);
      clone.setAttribute('data-pam-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-pam-group');
      var links = clone.querySelectorAll('a');
      for (var i = 0; i < links.length; i++) links[i].setAttribute('tabindex', '-1');
      return clone;
    }

    function build() {
      removeClones();
      loopWidth = group.offsetWidth;
      if (loopWidth === 0) return;

      var copiesNeeded = Math.ceil((row.offsetWidth + loopWidth) / loopWidth);
      for (var c = 0; c < copiesNeeded; c++) track.appendChild(cloneGroup());

      offset = offset % loopWidth;
      render();
    }

    function render() {
      var x = direction === 1 ? offset - loopWidth : -offset;
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function advance(seconds) {
      if (loopWidth === 0 || (pauseOnHover && hovered)) return;
      offset = (offset + speed * seconds) % loopWidth;
      render();
    }

    if (pauseOnHover) {
      row.addEventListener('mouseenter', function () { hovered = true; });
      row.addEventListener('mouseleave', function () { hovered = false; });
    }

    var images = group.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      if (!images[i].complete) images[i].addEventListener('load', build, { once: true });
    }

    build();
    return { build: build, advance: advance };
  }

  function initMarquee(root) {
    if (!root || root.dataset.pamInitialized === 'true') return;
    root.dataset.pamInitialized = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = parseFloat(root.dataset.speed) || 0;
    if (speed <= 0) return;

    var pauseOnHover = root.dataset.pauseOnHover === 'true';
    var rows = [];
    var rowElements = root.querySelectorAll('[data-pam-row]');
    for (var i = 0; i < rowElements.length; i++) {
      var row = createRow(rowElements[i], speed, pauseOnHover);
      if (row) rows.push(row);
    }
    if (rows.length === 0) return;

    var frame = null;
    var lastTime = 0;

    function tick(now) {
      var seconds = lastTime ? Math.min((now - lastTime) / 1000, MAX_FRAME_SECONDS) : 0;
      lastTime = now;
      for (var r = 0; r < rows.length; r++) rows[r].advance(seconds);
      frame = window.requestAnimationFrame(tick);
    }

    function start() {
      if (frame) return;
      lastTime = 0;
      frame = window.requestAnimationFrame(tick);
    }

    function stop() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = null;
    }

    function rebuildAll() {
      for (var r = 0; r < rows.length; r++) rows[r].build();
    }

    var resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(rebuildAll, 200);
    }
    window.addEventListener('resize', onResize);

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) start(); else stop();
      });
      observer.observe(root);
    } else {
      start();
    }

    root.addEventListener('pam:destroy', function () {
      stop();
      window.removeEventListener('resize', onResize);
      if (observer) observer.disconnect();
    });
  }

  function initAll(scope) {
    var marquees = (scope || document).querySelectorAll('[data-press-awards-marquee]');
    for (var i = 0; i < marquees.length; i++) initMarquee(marquees[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var marquee = event.target.querySelector('[data-press-awards-marquee]');
    if (marquee) marquee.dispatchEvent(new CustomEvent('pam:destroy'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initUgcCarousel(root) {
    if (!root || root.dataset.ssUgcInitialized === 'true') return;

    var track = root.querySelector('[data-ss-track]');
    if (!track) return;

    root.dataset.ssUgcInitialized = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ss-card]'));
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ss-video]'));
    var controls = root.querySelector('[data-ss-controls]');
    var dotsWrap = root.querySelector('[data-ss-dots]');
    var prev = root.querySelector('[data-ss-prev]');
    var next = root.querySelector('[data-ss-next]');
    var dots = [];

    /* Navigation works in card indexes rather than viewport widths. On mobile a
       card is only 82% of the viewport, so scrolling by a full viewport would
       overshoot and skip cards. */
    function cardOffsets() {
      var trackLeft = track.getBoundingClientRect().left;
      return cards.map(function (card) {
        return card.getBoundingClientRect().left - trackLeft + track.scrollLeft;
      });
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function visibleCards() {
      var offsets = cardOffsets();
      var viewLeft = track.scrollLeft;
      var viewRight = viewLeft + track.clientWidth;
      var visible = [];

      for (var i = 0; i < offsets.length; i++) {
        var width = cards[i].offsetWidth;
        var overlap = Math.min(offsets[i] + width, viewRight) - Math.max(offsets[i], viewLeft);
        /* The peeking card on mobile is only partly on screen, so require most
           of a card to be showing before it counts as visible. */
        if (width > 0 && overlap / width > 0.6) visible.push(i);
      }

      if (visible.length === 0) visible.push(0);
      return visible;
    }

    function syncActiveDots() {
      if (dots.length === 0) return;

      var visible = visibleCards();

      for (var i = 0; i < dots.length; i++) {
        var isActive = visible.indexOf(i) !== -1;
        dots[i].classList.toggle('active', isActive);
        if (isActive) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }

      /* A single active dot gets the elongated pill treatment used by the
         testimonials carousel; a highlighted range stays as plain circles. */
      if (dotsWrap) dotsWrap.classList.toggle('is-range', visible.length > 1);
    }

    function scrollToCard(index) {
      var offsets = cardOffsets();
      var clamped = Math.max(0, Math.min(index, offsets.length - 1));

      track.scrollTo({
        left: Math.min(offsets[clamped], maxScroll()),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    function buildDots() {
      if (!dotsWrap || !controls) return;

      var hasOverflow = maxScroll() > 4;
      controls.hidden = !hasOverflow;

      if (!hasOverflow) {
        dotsWrap.innerHTML = '';
        dots = [];
        return;
      }

      if (dots.length !== cards.length) {
        dotsWrap.innerHTML = '';
        dots = [];
        for (var i = 0; i < cards.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ss-ugc-dot';
          dot.setAttribute('aria-label', 'Go to video ' + (i + 1) + ' of ' + cards.length);
          dot.addEventListener('click', scrollToCard.bind(null, i));
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }
      }

      syncActiveDots();
    }

    function step(direction) {
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll() - 2;

      if (direction > 0 && atEnd) return scrollToCard(0);
      if (direction < 0 && atStart) return scrollToCard(cards.length - 1);

      scrollToCard(visibleCards()[0] + direction);
    }

    if (next) next.addEventListener('click', step.bind(null, 1));
    if (prev) prev.addEventListener('click', step.bind(null, -1));

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncActiveDots, 80);
      },
      { passive: true }
    );

    if (window.ResizeObserver) {
      new ResizeObserver(buildDots).observe(track);
    } else {
      window.addEventListener('resize', buildDots);
    }

    buildDots();

    function loadVideo(video) {
      if (video.dataset.ssLoaded === 'true') return;
      video.dataset.ssLoaded = 'true';
      video.muted = true;
      video.src = video.dataset.src;
    }

    function muteAllExcept(video) {
      for (var i = 0; i < videos.length; i++) {
        if (videos[i] === video) continue;
        videos[i].muted = true;
        var card = videos[i].closest('[data-ss-card]');
        if (card) card.classList.remove('is-unmuted');
      }
    }

    function toggleSound(video) {
      var card = video.closest('[data-ss-card]');
      loadVideo(video);

      if (video.muted) {
        muteAllExcept(video);
        video.muted = false;
        if (card) card.classList.add('is-unmuted');
        var playback = video.play();
        if (playback && playback.catch) playback.catch(function () {});
      } else {
        video.muted = true;
        if (card) card.classList.remove('is-unmuted');
      }

      var button = card ? card.querySelector('[data-ss-sound]') : null;
      if (button) {
        var label = video.getAttribute('aria-label') || 'video';
        button.setAttribute('aria-label', (video.muted ? 'Unmute ' : 'Mute ') + label);
      }
    }

    cards.forEach(function (card) {
      var video = card.querySelector('[data-ss-video]');
      if (!video) return;

      card.addEventListener('click', function () {
        toggleSound(video);
      });

      var button = card.querySelector('[data-ss-sound]');
      if (button) {
        button.addEventListener('click', function (event) {
          event.stopPropagation();
          toggleSound(video);
        });
      }
    });

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    var preloader = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadVideo(entry.target);
          preloader.unobserve(entry.target);
        });
      },
      { rootMargin: '300px' }
    );

    var player = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (reduceMotion) return;
            loadVideo(video);
            var playback = video.play();
            if (playback && playback.catch) playback.catch(function () {});
          } else {
            video.pause();
            video.muted = true;
            var card = video.closest('[data-ss-card]');
            if (card) card.classList.remove('is-unmuted');
          }
        });
      },
      { threshold: 0.5 }
    );

    videos.forEach(function (video) {
      preloader.observe(video);
      player.observe(video);
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-ss-ugc]');
    for (var i = 0; i < sections.length; i++) {
      initUgcCarousel(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ss-ugc]');
    if (section) initUgcCarousel(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
